import { useNavigation } from "@remix-run/react";
import { Button } from "~/components/ui/button";

import styles from "./SignInButton.module.scss";

export default function SignInButton() {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";
  const loadingPage = navigation.state === "loading";

  const loading = isSubmitting || loadingPage;

  return (
    <Button className={styles.button} type="submit">
      {loading && <div className={styles.loader} />}

      {!loading && "Kirjaudu sisään"}
    </Button>
  );
}
